// extracted by mini-css-extract-plugin
export default {"disable":"DisableButton__disable--TIUTA","disable_theme_light":"DisableButton__disable_theme_light---loc5","disable_theme_dark":"DisableButton__disable_theme_dark--3gxce"};